import { createContext, useContext, useEffect } from 'react';

/**
 * ThemeContext simplificado - sempre usa dark mode
 * Mantido para compatibilidade com código existente
 */

type Theme = 'dark';

interface ThemeContextType {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  resolvedTheme: 'dark';
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Aplicar dark mode uma única vez na inicialização
    const root = document.documentElement;
    root.setAttribute('data-theme', 'dark');
    root.classList.remove('light');
    root.classList.add('dark');
  }, []);

  // setTheme não faz nada, mas mantido para compatibilidade
  const setTheme = () => {
    // No-op: sempre dark mode
  };

  return (
    <ThemeContext.Provider value={{ theme: 'dark', setTheme, resolvedTheme: 'dark' }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
